<template>

    <v-modal title="Preview Form" :loading="starting" :padding="false">

        <template #body>
            <div id="form-container" />
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <div></div>
        </template>

    </v-modal>

</template>

<script>

import FormApi from '@api/FormApi';

export default {

    data() {
        return {
            starting: true,
        }
    },

    computed: {

        form() {
            return this.$store.getters['form/form'];
        },

    },

    mounted() {
        this.getForm();
    },

    methods: {

        getForm() {
            FormApi.getForm(this.form.id)
                .then((response) => {
                    this.starting = false;
                    this.$store.commit('form/setForm', response.data.data);
                    this.$nextTick(() => {
                        this.setHtml();
                    });
                })
                .catch(() => {
                    this.starting = false;
                });
        },

        setHtml() {
            const target = document.getElementById('form-container');
            // Set content.
            const content = document.createElement('div');
            content.innerHTML = this.form.embed.html;
            const style = document.createElement('style');
            style.innerHTML = this.form.embed.css;
            // Set iframe content.
            const iframe = document.createElement('iframe');
            target.appendChild(iframe);
            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(style.outerHTML);
            iframe.contentWindow.document.write(content.innerHTML);
            iframe.contentWindow.document.close();
            iframe.style.border = 0;
            iframe.style.height = iframe.contentDocument.body.scrollHeight + 'px';
            iframe.style.width = '100%';
            iframe.contentWindow.document.getElementsByClassName('cp-form-button')[0].disabled = true;
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
